<template>
  <v-flex xs12>
    <v-layout row wrap fluid>
      <v-snackbar
        v-model="messageError.show"
        color="error"
        top
        :timeout="messageError.timeout"
        text-xs-center
      >
        {{ messageError.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>
      <v-snackbar
        v-model="messageSuccess.show"
        color="success"
        top
        :timeout="messageSuccess.timeout"
        text-xs-center
      >
        {{ messageSuccess.message }}
        <v-icon right dark>check</v-icon>
      </v-snackbar>

      <v-flex xs2 sm2 text-xs-center class="my-auto">
        <v-layout row wrap>
          <v-flex xs1>
            <v-tooltip top>
              <template v-slot:activator="{ exitToolTip }">
                <v-btn
                  small
                  icon
                  fab
                  color="error"
                  dark
                  v-on="exitToolTip"
                  @click="$router.push({ name: 'home' })"
                  class="quitButton"
                  title="Kilépés a Főoldalra"
                >
                  <v-icon>highlight_off</v-icon>
                </v-btn>
              </template>
              <span>Kilépés</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm8 text-xs-justify>
        <v-alert
          v-model="infoShow"
          color="info"
          icon="info"
          centered
          dark
          class="overViewInfo"
        >
          <ol>
            <li style="font-size:13px;">
              Valószinű, hogy most már jobban érted a videót, de a felismerés ne
              tévesszen meg - ez még passzív tudás - az aktív tudásért
              ismételned kell újra és újra
            </li>
            <li style="font-size:13px;">
              Akkor lesz aktív a tudásod, ha a lecke tartalmát gondolkodás
              nélkül el tudod magyarázni hangosan - 1 hét múlva
            </li>
            <li style="font-size:13px;">
              Nézd meg a leckét többször 1 héten keresztül, amíg nem mennek
              reflexszerűen a mondatok
            </li>
            <li style="font-size:13px;">
              Memorizálás - Írás: ezek a dolgok nem segítenek, inkább hagyd el.
              <br />
              Csak sok ismétléssel képes az agyunk a hosszú távú memóriába
              elmenteni az infót. <br />
              Ismételj és menni fog az angol
            </li>
          </ol>
        </v-alert>
      </v-flex>

      <v-flex xs12 offset-md1 md10 text-xs-center>
        <v-expansion-panel dark class="">
          <v-expansion-panel-content
            v-for="(question, index) in questions"
            :key="index"
            class="bgBlue p-3"
            value="0"
          >
            <template v-slot:header>
              <!-- <v-layout row wrap>
                                <v-flex xs3> -->
              <!-- <v-btn 
                                    color="#b6d000" 
                                    fab 
                                    @click.native.stop="activateQuestion( question )"
                                    v-show="!question.playedQuestion"
                                    >
                                        <v-icon >volume_mute</v-icon>
                                    </v-btn>
                                    <v-btn 
                                        color="#b6d000" 
                                        fab 
                                        @click.native.stop="activateQuestion( question )"
                                        v-show="question.playedQuestion"
                                    >
                                        <v-icon>volume_up</v-icon>
                                    </v-btn> -->
              <!-- </v-flex>
                                <v-flex xs9> -->
              <h4
                v-if="
                  question.sentence !== null && question.sentence.length > 0
                "
                class="text-xs-center text-md-left"
              >
                <v-layout>
                  <v-flex xs2 mr-3>
                    <v-btn
                      color="#b6d000"
                      fab
                      @click.native.stop="activateQuestion(question)"
                      v-show="!question.playedQuestion"
                    >
                      <v-icon>volume_mute</v-icon>
                    </v-btn>
                    <v-btn
                      color="#b6d000"
                      fab
                      @click.native.stop="activateQuestion(question)"
                      v-show="question.playedQuestion"
                    >
                      <v-icon>volume_up</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs10 my-auto>
                    <div
                      v-show="!question.showTitle"
                      class="mt-1 overViewTitle"
                    >
                      {{ question.sentence }}
                    </div>
                    <div v-show="question.showTitle" class="mt-1 overViewTitle">
                      {{ question.title }}
                    </div>
                  </v-flex>
                </v-layout>
              </h4>

              <h4 v-else class="text-xs-center text-md-left">
                <div class="mt-1 overViewTitle">
                  Összesítés
                </div>
              </h4>
              <!-- </v-flex> -->
              <!-- </v-layout> -->
            </template>
            <v-card class="bgLight">
              <v-card-text>
                <v-card
                  v-for="(lingron, index) in question.lingrons"
                  :key="index"
                  class="bgLingronColor m-3 p-2 text-xs-center overViewLingron pilled"
                  :class="{ bgLingronHeardColor: lingron.soundHeard }"
                  @click="activateLingron(lingron)"
                >
                  <v-layout row wrap>
                    <v-flex xs1>
                      <v-icon v-show="!lingron.showOtherLang"
                        >volume_mute</v-icon
                      >
                      <v-icon v-show="lingron.showOtherLang">volume_up</v-icon>
                    </v-flex>
                    <v-flex xs11>
                      <div v-show="!lingron.showOtherLang">
                        {{ lingron.main_lang }}
                      </div>
                      <div v-show="lingron.showOtherLang">
                        {{ lingron.other_lang }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12 offset-md2 md8 text-xs-center>
        <h1>
          Önértékelés
          <v-btn fab color="info" dark small @click="infoModal.show = true">
            <!-- Információ -->
            <v-icon>info</v-icon>
          </v-btn>
        </h1>
      </v-flex>

      <v-flex xs12 offset-md2 md8 text-xs-center>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-card
              color="#b6d000"
              dark
              large
              class="p-3 clickable"
              :class="button.happy"
              @click="storeSelfValue(1)"
            >
              <img
                :src="require('@/assets/img/smiley_happy2.png')"
                alt="happy"
                class="overViewImg"
              />
              Könnyen ment
            </v-card>
          </v-flex>
          <v-flex xs12 md6>
            <v-card
              color="#f22012"
              dark
              large
              class="p-3 clickable"
              :class="button.sad"
              @click="storeSelfValue(2)"
            >
              <img
                :src="require('@/assets/img/smiley_sad2.png')"
                alt="sad"
                class="overViewImg"
              />
              Nehezen ment
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-dialog v-model="infoModal.show" width="600">
        <v-toolbar color="mainBlue" dark>
          <v-toolbar-title>Mennyire vagy elégedett magaddal? </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="infoModal.show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card>
          <v-card-text @click="infoModal.show = false">
            <p>
              Jelöld be magadnak, hogy mennyit kell még gyakorolnod ezzel a
              leckével!
            </p>
            <p>
              Ha csak néhány helyen akadtál meg, akkor kattints a ‘Könnyen ment’
              gombra. A késöbbiekben addig gyakorolj a leckével itt, amig
              reflexszerűen nem mennek a mondatok es panelek.
            </p>
            <p>
              Amennyiben sok helyen akadtál meg, azt javasoljuk, hogy kattints a
              ‘Nehezen ment ‘ gombra. Ez esetben a teljes leckét vedd újra
              addig, amíg nem megy könnyen a tananyag.
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from 'axios';

export default {
  components: {},
  data: () => ({
    messageSuccess: {
      show: false,
      message: '',
      timeout: 4500
    },
    messageError: {
      show: false,
      message: '',
      timeout: 4500
    },
    lessonId: '',
    lesson: '',
    questions: '',
    playedNow: false,
    infoShow: true,
    infoModal: {
      show: false
    },
    button: {
      sad: '',
      happy: ''
    }
  }),
  methods: {
    getLessonData() {
      this.$data.lessonId = this.$route.params.lessonId;

      axios
        .post(this.$store.getters.getApiUrl + '/api/lesson/overview', {
          token: this.$store.getters.getToken,
          lessonId: this.$data.lessonId
        })
        .then(response => {
          console.log('overview - resp: ', response.data);
          this.$data.lesson = response.data.lesson;
          this.$data.questions = response.data.questions;
          this.checkselfValueButton(response.data.selfValue);
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }
        });
    },
    storeSelfValue(value) {
      //Select the button
      this.checkselfValueButton(value);

      //Save the choice
      axios
        .post(
          this.$store.getters.getApiUrl + '/api/lesson/overview/selfValue',
          {
            token: this.$store.getters.getToken,
            lessonId: this.$data.lessonId,
            value: value
          }
        )
        .then(response => {
          // console.log('overview - resp: ', response.data);
          // this.$data.messageSuccess.message = response.data.message;
          // this.$data.messageSuccess.show = true;
          this.$router.push({ name: 'home' });
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }
        });
    },
    checkselfValueButton(value) {
      //Select the button
      if (value === 1) {
        this.$data.button.happy = 'selectedOverViewBtn';
        this.$data.button.sad = '';
      }

      if (value === 2) {
        this.$data.button.happy = '';
        this.$data.button.sad = 'selectedOverViewBtn';
      }

      if (value === undefined) {
        this.$data.button.happy = '';
        this.$data.button.sad = '';
      }
    },
    activateLingron(lingron) {
      //Play the audio file
      let sound =
        this.$store.getters.getApiUrl + '/uploads/sound/' + lingron.filename;
      var audio = new Audio(sound);

      if (!this.$data.playedNow) {
        this.$data.playedNow = true;
        lingron.soundHeard = true;
        lingron.showOtherLang = true;
        this.$data.voiceShow = true;

        audio.play();

        let v = this;
        setTimeout(function() {
          v.$data.playedNow = false;
          lingron.showOtherLang = false;
        }, 2700);
      }
    },
    activateQuestion(question) {
      //Play the audio file
      let sound =
        this.$store.getters.getApiUrl + '/uploads/sound/' + question.filename;
      var audio = new Audio(sound);

      if (!this.$data.playedNow && !question.playedQuestion) {
        //Show or hide the other lang question
        question.showTitle = true;
        this.$data.playedNow = true;
        question.playedQuestion = true;

        audio.play();

        let v = this;
        setTimeout(function() {
          v.$data.playedNow = false;
          question.playedQuestion = false;
          question.showTitle = false; //Hide question title
        }, 2700);
      }
    }
  },
  created: function() {
    this.getLessonData();
  },
  mounted() {}
};
</script>
